import { render, staticRenderFns } from "./AddWord.vue?vue&type=template&id=9ba92c02&scoped=true&"
import script from "./AddWord.vue?vue&type=script&lang=js&"
export * from "./AddWord.vue?vue&type=script&lang=js&"
import style0 from "./AddWord.vue?vue&type=style&index=0&id=9ba92c02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba92c02",
  null
  
)

export default component.exports